import logo from '@/assets/selise-legal-logo.svg';
import { Button } from '@/components/ui-kit/button';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SignupEmailSentPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  return (
    <div className="flex flex-col items-center gap-6 w-full max-w-md mx-auto font-nunito font-medium">
      <div className="w-32 h-14 mb-2">
        <img src={logo} className="w-full h-full" alt="logo" />
      </div>

      <div className="flex flex-col items-center gap-6 bg-white rounded-2xl p-8 w-full shadow-sm">
        <div className="w-20 h-20 rounded-full bg-amber-400 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 2L15 22l-4-9-9-4z" />
            <path d="M22 2L11 13" />
          </svg>
        </div>

        <div className="text-center">
          <h1 className="text-2xl font-bold text-high-emphasis mb-3">Please check your email</h1>
          <p className="text-sm text-medium-emphasis leading-relaxed">
            An email has been sent to{' '}
            <span className="text-selise-blue-500 font-semibold">{email}</span>. Please, follow the
            link on the email to continue your sign up.
          </p>
        </div>

        <Button asChild className="w-full" size="lg">
          <Link to="/login">{t('LOG_IN')}</Link>
        </Button>

        <div className="flex items-center gap-1 mt-2">
          <span className="text-sm text-medium-emphasis">
            Didn&apos;t receive an email? Contact our Support
          </span>
        </div>
      </div>
    </div>
  );
}

